
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { addGcashAccount, setConnectivityTest } from '@/api/gcash/account'
import { Form as ElForm } from 'element-ui'

@Component({
  name: 'addAccount',
  components: {}
})
export default class extends Vue {
  private infoForm: any = {
    phone_number: '',
    account_password: '',
    account_id: '',
    sms_id: ''
  }
  private rules: any = {
    phone_number: [
      {
        required: true,
        message: 'Please enter your mobile phone number',
        trigger: 'blur'
      }
    ],
    account_password: [
      { required: true, message: 'Please enter password', trigger: 'blur' }
    ],
    account_id: [
      {
        required: true,
        message: 'Please enter the account number',
        trigger: 'blur'
      }
    ]
    // sms_id: [
    //   {
    //     required: true,
    //     message: 'Please enter the sms forwarder ID',
    //     trigger: 'blur'
    //   }
    // ]
  }

  private testLoading: boolean = false
  private loading: boolean = false

  private back() {
    this.infoForm = {
      phone_number: '',
      account_password: '',
      account_id: '',
      sms_id: ''
    }
    this.$emit('close')
  }

  // private async connectivityTest() {
  //   try {
  //     this.testLoading = true
  //     const data: any = {
  //       action: 'start_login',
  //       data: {
  //         msisdn: this.infoForm.phone_number
  //       }
  //     }
  //     await setConnectivityTest(data).then(() => {
  //       this.$message({
  //         message: 'Sent，Please Check！',
  //         type: 'success'
  //       })
  //       this.testLoading = false
  //     })
  //   } catch (error) {
  //     this.testLoading = false
  //   }
  // }

  private async create() {
    (this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data: any = {
            ...this.infoForm
          }
          console.log(data)
          await addGcashAccount(data).then((res: any) => {
            this.$message({
              message: 'Create successful!',
              type: 'success'
            })
            this.loading = false
            this.back()
          })
        } catch (error) {
          this.loading = false
        }
      }
    })
  }

  mounted() {}
}
